const GoalType = Object.freeze( {
	ACTIVE: "ACTIVE",
	DRAFT: "DRAFT",
	ARCHIVED: "ARCHIVED",
} );

export default GoalType;

export const isValid = goalType => {
	return Object.keys( GoalType ).includes( goalType );
};



// WEBPACK FOOTER //
// ./src/constants/GoalType.js